module.exports = __webpack_public_path__ + "img/ssla.9644837f.png";